<button
  matButton="outlined"
  (click)="openDialog()"
  id="schedule-selector"
  type="button"
  class="item-selector tw-w-full"
>
  @if (scheduleSelectorService.selectedSchedules.length === 0) {
    <span class="text-muted">Select or add a new schedule</span>
  } @else {
    <span
      >{{ scheduleSelectorService.selectedSchedules.length }} schedules
      selected</span
    >
  }
  <mat-icon svgIcon="chevron-down" iconPositionEnd aria-hidden="true" />
</button>
